import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React from "react";
import { useEffect } from "react";
import { loginRequest } from "../authConfig";
import { Button } from "primereact/button";

const LogoutPage = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    instance.initialize().then(() => {
      if (isAuthenticated) {
        instance.logoutRedirect();
      }
    });
  }, [isAuthenticated]);

  return (
    <>
      <div className="triangle-image">
        <img src={import.meta.env.VITE_LOGIN_BACKGROUND_URL} alt="Background Image" />
      </div>

      <div className="w-full absolute top-0 bottom-0 left-0 right-0 m-auto flex items-center justify-center h-auto flex-col">
        <div className="bg-grey logout-img">
          {" "}
          <img src="/assets/icons/logout.svg" />
        </div>
        <div className="my-5 text-purple">You have successfully logged out of the Kindergarten Inclusion Support Portal</div>
        <Button
          className="border-0! rounded-none! bg-transparent!"
          label="Sign in"
          onClick={() => {
            instance.loginRedirect(loginRequest);
          }}>
          {" "}
        </Button>
        <div className="text-purple font-bold"></div>
      </div>
    </>
  );
};

export default LogoutPage;
